import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {ApiMessageService} from '../../core/api-message.service';
import {Router} from '@angular/router';
import {ConfigService} from '../../core/config.service';
import { RuoloPersonaService } from './ruolopersona.service';

@Injectable()
export class RuoloPersonaProvvService extends RuoloPersonaService {

  public static ROUTE = 'ruolopersona/provv';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public getRoute(): string {
    return RuoloPersonaProvvService.ROUTE;
  }

}
